import { Navigate, Route, Routes } from "react-router-dom";
import { AdminShell } from "../layouts/AdminShell";
import { MemberShell } from "../layouts/MemberShell";
import { PublicShell } from "../layouts/PublicShell";
import {
  AuditLogPage,
  AdminCoreDashboardPage,
  FeatureFlagsPage,
  RoleMatrixPage,
  SettingsPage,
} from "../pages/AdminCorePages";
import { AdminTaxonomyPage } from "../pages/AdminTaxonomyPage";
import {
  ForgotPasswordPage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
  VerifyEmailPage,
} from "../pages/AuthPages";
import { DogEditorPage, MemberDogsPage } from "../pages/DogMemberPages";
import { DogModerationPage } from "../pages/DogModerationPage";
import { PublicDogDirectoryPage } from "../pages/DogPublicPages";
import {
  AdminFoundationPage,
  ComponentCatalogPage,
  ErrorPage,
  LoadingPage,
  NotFoundPage,
} from "../pages/FoundationPages";
import {
  MemberDashboardPage,
  OnboardingPage,
  ProfileSettingsPage,
  PublicMemberProfilePage,
  SecuritySettingsPage,
} from "../pages/MemberAccountPages";
import { MemberTaxonomyPage } from "../pages/MemberTaxonomyPage";
import { OwnershipDogIndexPage } from "../pages/OwnershipDogIndexPage";
import {
  DogOwnershipPage,
  MemberOwnershipInboxPage,
  OwnershipModerationPage,
} from "../pages/OwnershipPages";
import {
  MemberPedigreePage,
  PedigreeModerationPage,
} from "../pages/PedigreePagesV2";
import { ProductHomePage } from "../pages/PublicPages";
import { PublicPedigreeProfilePage } from "../pages/PublicPedigreeProfilePage";
import { PublicDogAuthorityPage } from "../pages/PublicDogAuthorityPage";
import "../styles/pedigree-v2-fix.css";

export function App() {
  return (
    <Routes>
      <Route element={<PublicShell />}>
        <Route index element={<ProductHomePage />} />
        <Route path="dogs" element={<PublicDogDirectoryPage />} />
        <Route path="dogs/:slug/pedigree" element={<PublicPedigreeProfilePage />} />
        <Route path="dogs/:slug" element={<PublicDogAuthorityPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="u/:slug" element={<PublicMemberProfilePage />} />
        <Route path="components" element={<ComponentCatalogPage />} />
        <Route path="loading" element={<LoadingPage />} />
        <Route path="403" element={<ErrorPage status={403} />} />
        <Route path="500" element={<ErrorPage status={500} />} />
      </Route>
      <Route path="member" element={<MemberShell />}>
        <Route index element={<MemberDashboardPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="dogs" element={<MemberDogsPage />} />
        <Route path="dogs/new" element={<DogEditorPage />} />
        <Route path="dogs/:id/edit" element={<DogEditorPage />} />
        <Route path="dogs/:id/pedigree" element={<MemberPedigreePage />} />
        <Route path="dogs/:id/ownership" element={<DogOwnershipPage />} />
        <Route path="ownership" element={<MemberOwnershipInboxPage />} />
        <Route path="ownership/dogs" element={<OwnershipDogIndexPage />} />
        <Route path="moderation/dogs" element={<DogModerationPage />} />
        <Route path="moderation/ownership" element={<OwnershipModerationPage />} />
        <Route path="moderation/pedigree" element={<PedigreeModerationPage />} />
        <Route path="profile" element={<ProfileSettingsPage />} />
        <Route path="security" element={<SecuritySettingsPage />} />
        <Route path="taxonomy" element={<MemberTaxonomyPage />} />
      </Route>
      <Route path="admin" element={<AdminShell />}>
        <Route index element={<AdminCoreDashboardPage />} />
        <Route path="dogs" element={<DogModerationPage />} />
        <Route path="ownership" element={<OwnershipModerationPage />} />
        <Route path="pedigree" element={<PedigreeModerationPage />} />
        <Route path="roles" element={<RoleMatrixPage />} />
        <Route path="taxonomy" element={<AdminTaxonomyPage />} />
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="feature-flags" element={<FeatureFlagsPage />} />
        <Route path="system" element={<AdminFoundationPage />} />
      </Route>
      <Route path="404" element={<NotFoundPage />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
